var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2F36",
    d: "M14.09 0H4.704A4.71 4.71 0 0 0 0 4.705v8.59A4.71 4.71 0 0 0 4.703 18h9.388a4.71 4.71 0 0 0 4.703-4.705v-8.59A4.71 4.71 0 0 0 14.091 0M1.66 4.705A3.05 3.05 0 0 1 4.702 1.66h9.388a3.05 3.05 0 0 1 3.044 3.045v8.59a3.05 3.05 0 0 1-3.044 3.045H4.703a3.05 3.05 0 0 1-3.044-3.045z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2F36",
    d: "M9.398 13.374a4.38 4.38 0 0 0 4.375-4.376 4.38 4.38 0 0 0-4.375-4.376 4.38 4.38 0 0 0-4.375 4.376 4.38 4.38 0 0 0 4.375 4.376m0-7.091a2.72 2.72 0 0 1 2.716 2.716 2.72 2.72 0 0 1-2.716 2.717 2.72 2.72 0 0 1-2.715-2.717 2.72 2.72 0 0 1 2.715-2.716M14.177 5.33a1.18 1.18 0 0 0 0-2.358 1.18 1.18 0 0 0 0 2.358"
  })));
};
export default SvgInstagram;